import { Injectable } from '@angular/core';

@Injectable()
export class FrsResolvesService {

    constructor() {
    }

    security(project: any, ProjectModel: any) {
        return ProjectModel.checkPermission(project, 'frs');
    }

    frsTour(TourService: any, $transition$: any) {
        // When a state has children, you have to avoid
        // inheriting the tour setting.
        const toState = $transition$.to();
        if (toState && toState.name == 'home.project.summary.frs') {
            return TourService.setTour('releaseHomeCtrl');
        }
    }

    roadmapTour(TourService: any) {
        return TourService.setTour('releaseRoadmapCtrl');
    }
}
